
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import stripeService from "./StripeService"



const initialState = {
    isLoading: false,
    message: null,
    clientSecret: null,
    status: "idle",
    error: null,
    paymentMethodId: null,
    stripeCustomerId: null,
    paymentId: null,
    cardNumber: null,
    expiryDate: null,
    cvc: null,
    postalCode: null,
    payment_method: "stripe",
    payment_method_title: "Credit Card (Stripe)",

};


export const createPaymentIntent = createAsyncThunk('stripe/createPaymentIntent', async (data, thunkAPI) => {
        try {

            const response = await stripeService.createPaymentIntent(data);

            return response;
        } catch (error) {
            const paymentMessage =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(paymentMessage);
        }
    }
);



export const createStripeCustomer = createAsyncThunk('stripe/createStripeCustomer', async (data, thunkAPI) => {

        try {

            const response = await stripeService.createStripeCustomer(data);

            return response;
        } catch (error) {
            const paymentMessage =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(paymentMessage);
        }
    }
);





const stripeSlice = createSlice({
    name: 'stripe',
    initialState,
    reducers: {
        updatePaymentMethodId: (state, action) => {
            state.paymentMethodId = action.payload;
        },
        updateClientSecret: (state, action) =>{
            state.clientSecret = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(createPaymentIntent.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createPaymentIntent.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.clientSecret = action.payload.clientSecret;
                state.paymentId = action.payload.paymentId;
                state.error = null;
            })
            .addCase(createPaymentIntent.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })


            .addCase(createStripeCustomer.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createStripeCustomer.fulfilled, (state, action) => {
                state.status = 'succeeded';

                state.stripeCustomerId = action.payload.customerId;
                state.error = null;
            })
            .addCase(createStripeCustomer.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

    },
});

export const { updatePaymentMethodId, updateClientSecret } = stripeSlice.actions;
export default stripeSlice.reducer;
